import { render, staticRenderFns } from "./inclusive.vue?vue&type=template&id=456a88af&scoped=true&"
import script from "./inclusive.vue?vue&type=script&lang=js&"
export * from "./inclusive.vue?vue&type=script&lang=js&"
import style0 from "./inclusive.vue?vue&type=style&index=0&id=456a88af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a88af",
  null
  
)

export default component.exports